import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SeoHead from '@/components/feature/SeoHead';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://www.diariode1trader.com';

const liveTrades = [
  { time: '14:32', pair: 'NQ1!', type: 'BUY', result: '+$340', positive: true },
  { time: '13:58', pair: 'ES1!', type: 'SELL', result: '-$120', positive: false },
  { time: '13:21', pair: 'CL1!', type: 'BUY', result: '+$210', positive: true },
  { time: '12:44', pair: 'GC1!', type: 'BUY', result: '+$580', positive: true },
  { time: '11:59', pair: 'NQ1!', type: 'SELL', result: '+$275', positive: true },
  { time: '11:15', pair: 'ES1!', type: 'BUY', result: '-$90', positive: false },
  { time: '10:42', pair: 'NQ1!', type: 'BUY', result: '+$460', positive: true },
  { time: '10:08', pair: 'CL1!', type: 'SELL', result: '+$195', positive: true },
];

const stats = [
  { icon: 'ri-line-chart-line', label: 'P&L Hoje', value: '+$1.850', positive: true },
  { icon: 'ri-percent-line', label: 'Win Rate Mensal', value: '67%', positive: true },
  { icon: 'ri-exchange-line', label: 'Operações Hoje', value: '8', positive: null },
];

const tradingLiveSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Trading Live | Operações em Tempo Real | Diário de 1 Trader',
  description: 'Acompanhe as operações em tempo real no Diário de 1 Trader. Feed ao vivo de futuros NQ, ES, CL e GC com resultados e estatísticas.',
  url: `${siteUrl}/trading-live`,
  inLanguage: 'pt-PT',
  publisher: {
    '@type': 'Organization',
    name: 'Diário de 1 Trader',
    url: siteUrl,
  },
};

export default function TradingLivePage() {
  return (
    <div className="min-h-screen bg-[#0d1f3c]">
      <SeoHead
        title="Trading Live | Operações em Tempo Real | Diário de 1 Trader"
        description="Acompanhe as operações de trading de futuros em tempo real: NQ, ES, Crude Oil e Ouro. Feed ao vivo com resultados, estatísticas e gráfico TradingView."
        keywords="trading live, operações tempo real, futuros ao vivo, NQ ES CL GC, diário trader"
        canonical="/trading-live"
        schema={tradingLiveSchema}
      />
      <Navbar />
      <div className="pt-28 pb-20 max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-10">
          <div>
            <div className="flex items-center gap-3 mb-2">
              <span className="flex items-center gap-1.5 bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-full">
                <span className="w-2 h-2 bg-white rounded-full animate-pulse inline-block"></span>
                AO VIVO
              </span>
            </div>
            <h1 className="text-3xl md:text-4xl font-extrabold text-white">Operações em Tempo Real</h1>
            <p className="text-slate-400 mt-2">Acompanhe as nossas operações ao vivo nos mercados de futuros.</p>
          </div>
          <div className="flex gap-4">
            {stats.map((s) => (
              <div key={s.label} className="bg-[#1a3a6b] rounded-xl p-4 text-center min-w-[100px]">
                <div className="w-8 h-8 flex items-center justify-center mx-auto mb-2">
                  <i className={`${s.icon} text-blue-400 text-xl`}></i>
                </div>
                <div className={`text-xl font-extrabold ${s.positive === true ? 'text-green-400' : s.positive === false ? 'text-red-400' : 'text-white'}`}>{s.value}</div>
                <div className="text-xs text-slate-400 mt-0.5">{s.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* TradingView Chart */}
          <div className="lg:col-span-2 bg-[#1a3a6b] rounded-2xl overflow-hidden" style={{ height: '500px' }}>
            <iframe
              src="https://www.tradingview.com/widgetembed/?frameElementId=tradingview_widget&symbol=CME_MINI%3ANQ1%21&interval=5&theme=dark&style=1&locale=pt&toolbar_bg=%230d1f3c&enable_publishing=false&hide_top_toolbar=false&hide_legend=false&save_image=false&studies=[]&show_popup_button=false"
              style={{ width: '100%', height: '100%', border: 'none' }}
              title="TradingView Chart"
            />
          </div>

          {/* Live Feed */}
          <div className="bg-[#1a3a6b] rounded-2xl p-5 flex flex-col">
            <h3 className="text-white font-bold mb-4 flex items-center gap-2">
              <i className="ri-history-line text-blue-400"></i>
              Feed de Operações
            </h3>
            <div className="space-y-3 overflow-y-auto flex-1">
              {liveTrades.map((t, i) => (
                <div key={i} className={`flex items-center justify-between p-3 rounded-xl border-l-4 bg-[#0d1f3c]/60 ${t.positive ? 'border-green-500' : 'border-red-500'}`}>
                  <div>
                    <div className="flex items-center gap-2">
                      <span className={`text-xs font-bold px-2 py-0.5 rounded ${t.type === 'BUY' ? 'bg-green-500/20 text-green-400' : 'bg-red-500/20 text-red-400'}`}>{t.type}</span>
                      <span className="text-white font-semibold text-sm">{t.pair}</span>
                    </div>
                    <div className="text-slate-400 text-xs mt-0.5">{t.time}</div>
                  </div>
                  <span className={`font-bold text-sm ${t.positive ? 'text-green-400' : 'text-red-400'}`}>{t.result}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-8 bg-[#1a3a6b]/60 border border-blue-800 rounded-2xl p-6 text-center">
          <p className="text-slate-400 text-sm">
            <i className="ri-information-line mr-2"></i>
            Este feed é demonstrativo. Os resultados passados não garantem resultados futuros. Trading envolve risco de perda de capital.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
